import { AxiosRequestConfig } from 'axios';

const endpoint = '/api/access-token';
export default {
    generateToken: (data: any) => ({ method: 'POST', url: `${endpoint}`, data } as AxiosRequestConfig),
    retrieveTokens: () => ({ method: 'GET', url: `${endpoint}` } as AxiosRequestConfig),
    deleteToken: (id: number) => ({ method: 'DELETE', url: `${endpoint}/${id}` } as AxiosRequestConfig),
};
